import { useTranslation } from "react-i18next";
import iconOk from "../../static/svgs/icon-ok.svg";

const GetBulletTitleForCountrySelection = () => {
  const { t } = useTranslation();

  return t("content.prepareInformation");
};

const GetBulletsForCountrySelection = () => {
  const { t } = useTranslation();

  return [
    {
      icon: iconOk,
      iconAlt: "ok",
      id: "info_1",
      title: t("content.business"),
      text: t("content.businessDocumentsRequired")
    },
    {
      icon: iconOk,
      iconAlt: "ok",
      id: "info_2",
      title: t("content.peoples"),
      text: t("content.personalDocumentsRequired")
    },
    {
      icon: iconOk,
      iconAlt: "ok",
      id: "info_3",
      title: t("content.address"),
      text: t("content.addressRequired")
    }
  ];
};

const GetBulletsForCountrySelectionIntl = () => {
  const { t } = useTranslation();

  return [
    {
      icon: "check",
      iconAlt: "ok",
      id: "info_1",
      title: t("content.intlHomeInstructionsBusinessTitle"),
      text: t("content.intlHomeInstructionsBusinessText")
    },
    {
      icon: "check",
      iconAlt: "ok",
      id: "info_2",
      title: t("content.intlHomeInstructionsPeopleTitle"),
      text: t("content.intlHomeInstructionsPeopleText")
    },
    {
      icon: "check",
      iconAlt: "ok",
      id: "info_3",
      title: t("content.intlHomeInstructionsAddressTitle"),
      text: t("content.intlHomeInstructionsAddressText")
    }
  ];
};

export { GetBulletTitleForCountrySelection, GetBulletsForCountrySelection, GetBulletsForCountrySelectionIntl };
